var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCareersHero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 600,
    viewBox: "0 0 800 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0,
    x2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#06b6d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0ea5a4"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 600,
    rx: 24,
    fill: "url(#g)",
    opacity: 0.08
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80,80)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 320,
    height: 200,
    rx: 12,
    fill: "#fff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 280,
    height: 28,
    rx: 6,
    fill: "#0f172a",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 60,
    width: 240,
    height: 14,
    rx: 4,
    fill: "#0f172a",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 84,
    width: 180,
    height: 14,
    rx: 4,
    fill: "#0f172a",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 120,
    r: 84,
    fill: "#fff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 120c0-22 18-40 40-40s40 18 40 40-18 40-40 40-40-18-40-40z",
    fill: "#0ea5a4",
    opacity: 0.95
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareersHero);
export default __webpack_public_path__ + "static/media/CareersHero.0b8a8e2719602eafea240799746e715e.svg";
export { ForwardRef as ReactComponent };